import api from './api';
import type { InventoryDashboard, InventoryItemCategory, InventoryItemType } from '../types/venue';

const inventoryDashboardService = {
  getDashboard: async (
    venueId: string,
    category?: InventoryItemCategory | 'none',
    type?: InventoryItemType,
  ): Promise<InventoryDashboard> => {
    const params: Record<string, unknown> = {};
    if (category) params.category = category;
    if (type) params.type = type;
    const response = await api.get(`/admin/venue/${venueId}/inventory/dashboard`, { params });
    return response.data;
  },
};

export default inventoryDashboardService;
